import { useNavigate, useParams } from 'react-router-dom';
import '../CSS/Global.css';
import GreenBag from '../Images/green-bag.webp'
import { useEffect, useState } from 'react';

function Thankyou() {
    const { id } = useParams();
    const navigate=useNavigate();
    const [data,setData]=useState({})

    const fetchData = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/pay-all/order/${id}`)
            const res = await response.json();
            setData(res.data)
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData();
    }, [])
    return (
        <div className="success-page">
            <div className="success-page-img-wrapper">
                <div className="success-page-img">
                    <img src={GreenBag} alt="Thank You" />
                </div>
            </div>
            <h1>Booking / project confirmed! Thank you!</h1>
            <div className="success-btn">
                <button className="success-track-btn" onClick={()=>navigate(`/track/${data.transaction_id}`)}>
                    View production timeline
                </button>
                <button className="track-all-btn" onClick={()=>navigate(`/`)}>
                   Home
                </button>
            </div>

            <p>If you've any queries, please contact us on <span>support@filmakee.com</span></p>
        </div>
    );
}

export default Thankyou;
